export default {

    after: (field, [target]) => `${field} must appear later. ${target}.`,
    alpha_dash: (field) => `${field} can contain alphanumeric characters (A-Z a-z), numbers (0-9), dash (-) and underscore (_).`,
    alpha_num: (field) => `${field} can only contain alphanumeric characters.`,
    alpha_spaces: (field) => `${field} can only contain characters and spaces.`,
    alpha: (field) => `${field} can only contain alphanumeric characters.`,
    before: (field, [target]) => `${field} must appear first ${target}.`,
    between: (field, [min, max]) => `${field} must have a value between ${min} and ${max}.`,
    confirmed: (field, [target]) => `${field} is not match.`,
    credit_card: (field) => `Filled ${field} incorrect.`,
    date_between: (field, [min, max]) => `${field} must have a value between ${min} and ${max}.`,
    date_format: (field, [format]) => `${field} must have a value in the format ${format}.`,
    decimal: (field, [decimals] = ['*']) => `${field} can only contain numeric characters and decimal points ${decimals === '*' ? '' : decimals}.`,
    digits: (field, [length]) => `Field ${field} Can only contain numeric characters and must be of length${length}.`,
    dimensions: (field, [width, height]) => `${field} must have width${width} pixels and height  ${height} pixels.`,
    email: (field) => `${field} must be a valid email address.`,
    ext: (field) => `${field} must be a file.`,
    image: (field) => `Field ${field} must be an image.`,
    ip: (field) => `${field} must be a valid ip address.`,
    max: (field, [length]) => `${field} there can't be more ${length} characters.`,
    max_value: (field, [max]) => `${field} must be less than or equal to ${max}.`,
    mimes: (field) => `${field} must contain the appropriate file type.`,
    min: (field, [length]) => `${field} must contain at least ${length} characters.`,
    min_value: (field, [min]) => `${field} must be greater than or equal to ${min}.`,
    numeric: (field) => `${field} can only have numeric characters.`,
    regex: (field) => `${field} has incorrect format.`,
    required: (field) => `${field} is a required field.`,
    size: (field, [size]) => `${field} can only contain smaller files ${size} KB.`,
    url: (field) => `${field} is not a valid URL.`,
    excluded: (field) => `${field} must contain a valid value.`,
    included: (field) => `${field} must be a value.`,
    phone_rule: (field) => `${field} illegal`,
    is: (field, [field1, field2]) => `${field} does not match`,
}
